import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.label`
    //&& {
    //    align-items: flex-start;
    //}
`;
const LabelText = styled.div`
    flex-wrap: wrap;
    gap: 0.5ch;
`;
const Input = styled.input`
    color: currentColor;
    cursor: pointer;
    display: flex;
    width: var(--cr-text-lg);
    height: var(--cr-text-lg);

    && {
        appearance: none;
    }

    &:before {
        content: var(--cr-check-icon);
        transform: scale(0);
        transition: 120ms transform ease-in-out;
    }

    &:checked:before {
        transform: scale(1);
    }
`;

export type TProps = {
    label: string;
    name: string;
    checked: boolean;
    setValue: React.Dispatch<React.SetStateAction<boolean>>;
    isRequired?: boolean;
    children?: ReactNode;
}

const Checkbox: FC<TProps> = ({label, name, checked, setValue, isRequired, children}: TProps) => {
    return (
        <Container className="cr-flex cr-gap-sm cr-center">
            <Input
                className={'cr-rounded-full cr-text-base cr-border cr-border-primary'}
                type={'checkbox'}
                checked={checked}
                required={isRequired}
                onChange={(event) => setValue(event.target.checked)}
            />
            <LabelText className={'cr-flex'}>
                <span>{label}</span>
                {children}
            </LabelText>
        </Container>
    );
}

export default Checkbox;
